import { composeStateMachine } from '../../../module';
import { ReportSavedViewEditState } from '../records';
import { IReportSavedViewEditActiveCategory } from '../types';

export const reportSavedViewEditInitialState = ReportSavedViewEditState();

export const reportSavedViewEditState = composeStateMachine(
  'report-saved-views-edit',
  reportSavedViewEditInitialState,
  (compose) => ({
    setActiveTabIndex: compose.action((state, activeTabIndex: number) => state.set('activeTabIndex', activeTabIndex)),
    setShowSuccessMessage: compose.action((state, showMessage: boolean) =>
      state.set('showSuccessMessage', showMessage)
    ),
    setActiveCategory: compose.action((state, category: IReportSavedViewEditActiveCategory) =>
      state.set('activeCategory', category)
    )
  })
);

export const {
  actions: reportSavedViewEditActions,
  actionCreators: reportSavedViewEditActionCreators,
  reducer: reportSavedViewEditReducer,
  selector: reportSavedViewEditSelector
} = reportSavedViewEditState;
